














































import { Configuration, DoctorPaymentRestControllerApi, ReceiptOverview, ReceiptDetail } from '@/types/api-docs'
import { DataTableHeader } from 'vuetify'
import ReceiptForm from '@/components/ReceiptForm.vue'
import Vue from 'vue'

const paymentApi = new DoctorPaymentRestControllerApi(new Configuration({ basePath: `${window.location.origin}` }))

export type DataType = {
  pageName: string
  breadcrumbs: unknown[]
  receipt?: ReceiptDetail
  freeAddress: string
  downloadedReceipts?: Array<ReceiptOverview>
  paymentId: number
  headers: DataTableHeader[]
  isFormValid: boolean
  prevReceiptCount: number
  nowDownloadingReceipt: boolean
}

export type BreadcrumbsRow = {
  text: string
  href: string
  disabled: boolean
}

export default Vue.extend({
  components: {
    ReceiptForm,
  },
  computed: {
    downloadedReceiptsCount(): number {
      return this.downloadedReceipts ? this.downloadedReceipts.length : 0
    },
  },
  data(): DataType {
    return {
      pageName: this.$route.meta.title,
      breadcrumbs: [
        {
          text: 'HOME',
          href: '/member',
        },
        {
          text: this.$store.getters.preRoute?.meta.title || '支払情報',
          href: this.$store.getters.preRoute?.name ? this.$store.getters.preRoute?.path : '/member/payments',
          disabled: !this.$store.getters.preRoute?.name,
        },
        {
          text: `${this.$route.meta.title}`,
          disabled: true,
        },
      ],
      receipt: undefined,
      freeAddress: '',
      downloadedReceipts: [{}],
      paymentId: Number(this.$route.params.id),
      headers: [
        { text: 'No', value: 'id' },
        { text: '領収書番号', value: 'outputNo' },
        {
          text: '発行日',
          value: 'downloadedDate',
          sortable: false,
        },
        {
          text: '宛名',
          value: 'freeAddress',
        },
      ],
      isFormValid: true,
      prevReceiptCount: 0,
      nowDownloadingReceipt: false,
    }
  },
  async mounted() {
    this.replaceSecondBreadcrumb()

    await this.fetchReceiptDetail()
    await this.fetchReceiptOverviews()
  },
  methods: {
    replaceSecondBreadcrumb() {
      if (this.breadcrumbs.length < 2) {
        return
      }
      let row = this.breadcrumbs[1] as unknown as BreadcrumbsRow
      if (!row.disabled) {
        return
      }
      let pathElems = this.$route.path.split('/')
      const paymentType = pathElems.slice(-3)[0]
      pathElems.splice(pathElems.length - 2, 2)
      row.text = this.judgePageTitle(paymentType)
      row.href = pathElems.join('/')
      row.disabled = false

      this.breadcrumbs.splice(1, 1, row)
    },
    async fetchReceiptDetail() {
      const { data } = await paymentApi.fetchReceiptDetail(this.paymentId)
      this.receipt = data
    },
    async fetchReceiptOverviews() {
      const { data } = await paymentApi.fetchReceiptOverviews(this.paymentId)
      this.downloadedReceipts = data
    },
    async downloadCheckHandler() {
      await this.fetchReceiptOverviews()
      if (this.downloadedReceipts) {
        if (this.downloadedReceipts.length > this.prevReceiptCount) {
          await this.fetchReceiptDetail()
          this.nowDownloadingReceipt = false
          return
        }
      }

      window.setTimeout(this.downloadCheckHandler, 2000)
    },
    async downloadReceipt() {
      this.nowDownloadingReceipt = true
      this.prevReceiptCount = this.downloadedReceipts ? this.downloadedReceipts.length : 0

      window.setTimeout(this.downloadCheckHandler, 2000)

      window.location.href =
        window.location.origin +
        '/api/member/payments' +
        '/receipt/download/' +
        this.paymentId +
        '/' +
        encodeURI(this.freeAddress)
    },
    judgePageTitle(paymentType: string): string {
      if (paymentType === 'annualFees') {
        return '年会費一覧'
      } else if (paymentType === 'qualifications') {
        return '資格・認定入金一覧'
      } else if (paymentType === 'etcs') {
        return 'その他入金一覧'
      }
      return '支払情報'
    },
  },
})
